import React from "react";
import { Navigate } from "react-router-dom";
import { getToken, getUser } from "@/lib/auth";
import AdminDashboard from "@/pages/AdminDashboard";

/**
 * Dedicated, bookmarkable /crm entry point.
 *
 *  • Not logged in        -> admin login, returning to /crm afterwards.
 *  • Admin / Super Admin   -> full admin interface, landing on Outbound CRM.
 *  • Sales                 -> Outbound CRM, opened on "My Leads".
 *  • Recruiter (no crm)    -> Candidates area (no Outbound CRM exposed).
 *
 * Reuses the existing AdminDashboard + admin session; no separate app or data.
 * RBAC is enforced server-side and by the dashboard's permission-gated tabs.
 */
export default function CrmEntry() {
  const token = getToken();
  if (!token) {
    return <Navigate to="/admin?returnTo=/crm" replace />;
  }

  const perms = getUser()?.permissions || [];
  const hasCrm = perms.includes("crm.view");
  const isAdminLevel = perms.includes("crm.assign"); // only Admin/Super Admin

  let initialTab = "submissions";
  let initialCrmView;
  if (hasCrm) {
    initialTab = "outbound-crm";
    // Sales (CRM without admin-level assign) lands on their own "My Leads".
    initialCrmView = isAdminLevel ? "all" : "my";
  } else if (perms.includes("candidates.view")) {
    initialTab = "candidates";
  }

  return <AdminDashboard initialTab={initialTab} initialCrmView={initialCrmView} />;
}
